/* Nura Essentials — native Shopify AJAX cart and editorial header behaviors. */
(() => {
  const root = document.documentElement;
  const body = document.body;
  const header = document.querySelector('[data-nura-header]');
  const menu = document.querySelector('[data-nura-mobile-menu]');
  const menuToggle = document.querySelector('[data-nura-menu-toggle]');
  const drawer = document.querySelector('[data-nura-cart-drawer]');
  const overlay = document.querySelector('[data-nura-cart-overlay]');
  const itemsEl = document.querySelector('[data-nura-cart-items]');
  const footerEl = document.querySelector('[data-nura-cart-footer]');
  const countEls = document.querySelectorAll('[data-nura-cart-count]');
  const mobileCountEls = document.querySelectorAll('[data-nura-mobile-count]');
  const totalEl = document.querySelector('[data-nura-cart-total]');
  const toast = document.querySelector('[data-nura-cart-toast]');
  const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  const cartChangeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
  const moneyFormat = (window.nuraCartConfig && window.nuraCartConfig.moneyFormat) || '${{amount}}';
  let toastTimer;
  let lastTrigger;

  const endpoint = (url) => url.endsWith('.js') ? url : `${url}.js`;
  const shortTitle = (title = '') => {
    const text = title.toLowerCase();
    if (text.includes('copper peptide')) return 'Copper Peptide Cream';
    if (text.includes('exosome')) return 'Exosome Growth Factor Serum';
    if (text.includes('bundle') || text.includes('duo')) return 'The Nura Peptide Duo';
    return title;
  };
  const money = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, moneyFormat);
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  };
  const lock = () => body.classList.add('nura-lock-scroll');
  const unlockIfClosed = () => { if (!drawer.classList.contains('is-open') && !menu.classList.contains('is-open')) body.classList.remove('nura-lock-scroll'); };
  const showToast = (message, error = false) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.toggle('is-error', error);
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };
  const syncCount = (count) => {
    countEls.forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-hidden', count === 0);
      if (count > 0) { el.classList.add('is-updated'); window.setTimeout(() => el.classList.remove('is-updated'), 220); }
    });
    mobileCountEls.forEach((el) => { el.textContent = count || ''; });
  };
  const renderCart = (cart) => {
    syncCount(cart.item_count);
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (footerEl) footerEl.hidden = cart.item_count === 0;
    if (!itemsEl) return;
    if (!cart.item_count) {
      itemsEl.innerHTML = '<div class="nura-cart-empty"><p>Your cart is waiting for its essentials.</p><a class="nura-link" href="/collections/all" data-nura-cart-close>Shop Nura</a></div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map((item) => `
      <article class="nura-cart-item" data-nura-cart-key="${item.key}">
        <a class="nura-cart-item__image" href="${item.url || '/collections/all'}">${item.image ? `<img src="${item.image}" alt="${item.featured_image && item.featured_image.alt ? item.featured_image.alt.replace(/"/g, '&quot;') : shortTitle(item.product_title)}" width="90" height="110">` : ''}</a>
        <div class="nura-cart-item__content">
          <h3>${shortTitle(item.product_title)}</h3>
          <p>${money(item.final_line_price)}</p>
          <div class="nura-quantity"><button type="button" data-nura-cart-change="${item.key}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-nura-cart-change="${item.key}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div>
          <button type="button" class="nura-remove" data-nura-cart-change="${item.key}" data-quantity="0">Remove</button>
        </div>
      </article>`).join('');
  };
  const getCart = async () => {
    const response = await fetch(endpoint(cartUrl), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart could not be refreshed.');
    return response.json();
  };
  const openCart = async (trigger) => {
    if (!drawer) return;
    lastTrigger = trigger || document.activeElement;
    closeMenu();
    try { renderCart(await getCart()); } catch (error) { showToast(error.message, true); }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.querySelectorAll('[data-nura-cart-trigger]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    lock();
    drawer.querySelector('[data-nura-cart-close]')?.focus();
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.querySelectorAll('[data-nura-cart-trigger]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    unlockIfClosed();
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  };
  const openMenu = () => { closeCart(); menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); menuToggle.setAttribute('aria-expanded', 'true'); lock(); menu.querySelector('[data-nura-menu-close]')?.focus(); };
  const closeMenu = () => { if (!menu) return; menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); menuToggle?.setAttribute('aria-expanded', 'false'); unlockIfClosed(); };
  const setHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 26);

  document.querySelectorAll('[data-nura-cart-trigger]').forEach((button) => button.addEventListener('click', () => openCart(button)));
  document.querySelectorAll('[data-nura-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  menuToggle?.addEventListener('click', openMenu);
  document.querySelectorAll('[data-nura-menu-close], .nura-mobile-menu__nav a').forEach((el) => el.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeCart(); closeMenu(); } });
  window.addEventListener('scroll', setHeader, { passive: true }); setHeader();

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(endpoint(cartAddUrl), { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This item is currently unavailable.');
      const cart = await getCart();
      renderCart(cart);
      showToast(`${shortTitle(result.product_title || result.title)} added to cart.`);
      openCart(submit);
    } catch (error) { showToast(error.message || 'Unable to add this item.', true); }
    finally { if (submit) submit.disabled = false; }
  }, true);

  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-nura-cart-change]');
    if (!control) return;
    control.disabled = true;
    try {
      const response = await fetch(endpoint(cartChangeUrl), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: control.dataset.nuraCartChange, quantity: Number(control.dataset.quantity) }) });
      if (!response.ok) throw new Error('Cart could not be updated.');
      renderCart(await response.json());
    } catch (error) { showToast(error.message, true); }
    finally { control.disabled = false; }
  });
})();
